import * as React from "react";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <textarea
      ref={ref}
      className={twMerge(clsx("flex min-h-[100px] w-full rounded-md border border-slate-200 bg-white px-3 py-2 text-sm shadow-sm outline-none ring-offset-white placeholder:text-slate-400 focus:border-brand-orange focus:ring-2 focus:ring-brand-orange/20 disabled:cursor-not-allowed disabled:opacity-50", className))}
      {...props}
    />
  );
});
Textarea.displayName = "Textarea";

export { Textarea };
